import React, { useEffect, useRef, useState } from "react";
import { motion, useInView } from "framer-motion";

const AnimatedTimelineItem = ({ children }) => {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    amount: "some",
    margin: "-40% 0px -40% 0px", // top/bottom margin (negative pushes trigger zone down)
  });

  const [hasMounted, setHasMounted] = useState(false);

  useEffect(() => {
    setHasMounted(true);
  }, []);

  const shouldAnimate = hasMounted && isInView;

  return (
    <motion.div
      ref={ref}
      initial={{ scale: 1, opacity: 0.7 }}
      animate={{
        scale: shouldAnimate ? 1.05 : 1,
        opacity: shouldAnimate ? 1 : 0.7,
      }}
      transition={{ duration: 0.4, ease: "easeOut" }}
    >
      {children}
    </motion.div>
  );
};

export default AnimatedTimelineItem;
